import React from 'react';
import { PedagogicalChallengeSingleView } from './PedagogicalChallengeSingle.view';
import { useHistory } from 'react-router';
import { useQuery } from '@apollo/client';
import { Defi } from 'graphql/generated/graphql';
import QUERY_SINGLE_PEDAGOGICAL_CHALLENGE from 'graphql/query/defi/singleDefi';
import { LoadingLayout } from 'components/molecules/Loaders/LoadingLayout';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { GraphQLError } from 'graphql';

type GetDefiById = {
  getDefiById: Defi;
};

export const PedagogicalChallengeSingle = ({ match }) => {
  const { data, loading, error } = useQuery<GetDefiById>(
    QUERY_SINGLE_PEDAGOGICAL_CHALLENGE,
    {
      variables: { id: match?.params?.id }
    }
  );

  const history = useHistory();
  const goBack = () => history.goBack();

  if (loading) return <LoadingLayout />;
  if (error)
    return (
      <ErrorContainer
        detailErr={new GraphQLError(`Erreur dans la récupération du quiz`)}
      />
    );

  return (
    <PedagogicalChallengeSingleView
      goBack={goBack}
      defiData={data.getDefiById}
    />
  );
};
